import { Smartphone } from 'lucide-react'
import { GooglePlayBadge, AppStoreBadge } from './StoreBadges'
import { AppleLogo } from './AppleLogo'

const cols = [
  {
    icon: <Smartphone size={22} />,
    name: 'Android',
    badge: 'Live on Google Play',
    badgeTint: 'bg-emerald-50 text-status-successDark',
    note: 'Available on the Google Play Store — install in one tap.',
    store: <GooglePlayBadge height={50} />,
  },
  {
    icon: <AppleLogo size={20} />,
    name: 'iOS',
    badge: 'Live on the App Store',
    badgeTint: 'bg-emerald-50 text-status-successDark',
    note: 'Available on the App Store for iPhone — install in one tap.',
    store: <AppStoreBadge height={50} />,
  },
]

export function PlatformParity() {
  return (
    <section className="bg-white">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-20">
        <div className="max-w-2xl">
          <span className="chip bg-brand/10 text-brand">On your phone</span>
          <h2 className="mt-3">Native apps for iOS and Android.</h2>
          <p className="mt-3 text-ink-soft">
            Built for the way agents actually work — outdoors, on the road, in
            the customer&apos;s living room. No browser tabs to keep open.
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          {cols.map((c) => (
            <div key={c.name} className="card flex flex-col">
              <div className="flex items-center justify-between">
                <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-brand/10 text-brand">
                  {c.icon}
                </div>
                <span className={`chip ${c.badgeTint}`}>{c.badge}</span>
              </div>
              <h3 className="mt-4 text-lg">{c.name}</h3>
              <p className="mt-1 flex-1 text-sm text-ink-soft">{c.note}</p>
              <div className="mt-4">{c.store}</div>
            </div>
          ))}
        </div>

        <div className="mt-8 rounded-card border border-[var(--color-divider)] bg-[var(--color-nav)] p-5 text-center">
          <p className="text-sm font-medium text-ink">
            Prefer one link for any phone?{' '}
            <a
              href="https://bimauncle.com/get"
              className="font-semibold text-brand underline"
            >
              bimauncle.com/get
            </a>{' '}
            sends each device to the right store.
          </p>
        </div>
      </div>
    </section>
  )
}
